module.exports = {"origin":"http://localhost:8080","page":"http://localhost:8000"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/local.json
 ** module id = 756
 ** module chunks = 1
 **/